"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactGa = require("react-ga");

var _propTypes = require("prop-types");

var _H = _interopRequireDefault(require("../../Typography/H3"));

var _Chevron = _interopRequireDefault(require("../../Chevron/Chevron"));

var _ButtonGroup = _interopRequireDefault(require("../../ButtonGroup"));

var _LinkButton = _interopRequireDefault(require("../../LinkButton"));

var _spacing = _interopRequireDefault(require("../../../constants/spacing"));

var _colors = _interopRequireDefault(require("../../../constants/colors"));

var _utils = require("../utils");

var _Item = _interopRequireDefault(require("../Item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin-top: 0;\n\tbutton {\n\t\theight: 30px;\n\t}\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-bottom: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin-left: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: ", ";\n\toverflow: hidden;\n\tflex-wrap: wrap;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tcursor: pointer;\n\tfont-size: ", "px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin: ", " 0;\n\twidth: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Wrapper = _styledComponents.default.div(_templateObject(), _spacing.default.s2);

Wrapper.displayName = 'Wrapper';
var CH3 = (0, _styledComponents.default)(_H.default)(_templateObject2(), _spacing.default.s2);
CH3.displayName = 'H3';

var ItemContainer = _styledComponents.default.div(_templateObject3(), function (props) {
  return props.show ? 'flex' : 'none';
});

ItemContainer.displayName = 'ItemContainer';
var MLChevron = (0, _styledComponents.default)(_Chevron.default)(_templateObject4(), _spacing.default.s1);
MLChevron.displayName = 'MLChevron';

var Bar = _styledComponents.default.div(_templateObject5(), _spacing.default.s1);

Bar.displayName = 'Bar';
var LinkButtonGroup = (0, _styledComponents.default)(_ButtonGroup.default)(_templateObject6());
LinkButtonGroup.displayName = 'ButtonGroup';

var Group =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Group, _React$Component);

  function Group(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.toggleShow = _this.toggleShow.bind(_assertThisInitialized(_this));
    _this.state = {
      show: props.initialShow
    };
    return _this;
  }

  var _proto = Group.prototype;

  _proto.toggleShow = function toggleShow() {
    this.setState(function (_ref) {
      var show = _ref.show;
      return {
        show: !show
      };
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        title = _this$props.title,
        users = _this$props.users,
        _onClick = _this$props.onClick,
        hideButtons = _this$props.hideButtons,
        toggleUsers = _this$props.toggleUsers,
        GA = _this$props.GA;
    var show = this.state.show;
    var selectedUsers = (0, _utils.getSelected)(users);
    var deselectedUsers = (0, _utils.getNotSelected)(users);
    return _react.default.createElement(Wrapper, null, _react.default.createElement(Bar, null, _react.default.createElement(CH3, {
      onClick: function onClick() {
        if (show) {
          (0, _reactGa.event)({
            action: 'Contract Selected Group',
            category: GA.category
          });

          if (title === 'No group') {
            (0, _reactGa.event)({
              action: 'Contract No Group',
              category: GA.category
            });
          }
        } else {
          (0, _reactGa.event)({
            action: 'Expand Selected Group',
            category: GA.category
          });

          if (title === 'No group') {
            (0, _reactGa.event)({
              action: 'Expand No Group',
              category: GA.category
            });
          }
        }

        _this2.toggleShow();
      }
    }, title, " (", selectedUsers.length, ")", '  ', _react.default.createElement(MLChevron, {
      expanded: show,
      color: _colors.default.primary,
      size: 16
    })), !hideButtons && _react.default.createElement(LinkButtonGroup, null, _react.default.createElement(_LinkButton.default, {
      disabled: selectedUsers.length === users.length,
      onClick: function onClick() {
        (0, _reactGa.event)({
          action: 'Select Group',
          category: GA.category
        });
        toggleUsers(deselectedUsers.filter(_utils.filterDisabled).map(_utils.idMap));
      }
    }, "Select group"), _react.default.createElement(_LinkButton.default, {
      disabled: selectedUsers.length === 0,
      onClick: function onClick() {
        (0, _reactGa.event)({
          action: 'Deselect Group',
          category: GA.category
        });
        toggleUsers(selectedUsers.filter(_utils.filterDisabled).map(_utils.idMap));
      }
    }, "Deselect group"))), _react.default.createElement(ItemContainer, {
      show: show,
      "data-e2e": "Group-" + title
    }, users.map(function (_ref2) {
      var id = _ref2.id,
          firstName = _ref2.firstName,
          lastName = _ref2.lastName,
          other = _objectWithoutPropertiesLoose(_ref2, ["id", "firstName", "lastName"]);

      return _react.default.createElement(_Item.default, _extends({
        key: id,
        name: firstName + " " + lastName,
        onClick: function onClick() {
          return _onClick(id);
        }
      }, other));
    })));
  };

  return Group;
}(_react.default.Component);

Group.displayName = 'Group';
Group.propTypes = {
  GA: (0, _propTypes.shape)({
    category: _propTypes.string
  }).isRequired,
  users: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]).isRequired,
    firstName: _propTypes.string.isRequired,
    lastName: _propTypes.string.isRequired,
    selected: _propTypes.bool.isRequired,
    warning: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string])
  })).isRequired,
  onClick: _propTypes.func.isRequired,
  initialShow: _propTypes.bool,
  title: _propTypes.string,
  hideButtons: _propTypes.bool,
  toggleUsers: _propTypes.func.isRequired
};
Group.defaultProps = {
  initialShow: true,
  title: '',
  hideButtons: false
};
var _default = Group;
exports.default = _default;